$(document).ready(() => {
  // show/hide product filters
  $("#productFiltersBtn").on("click", function() {
    $("#productFilters").slideToggle();
    $("#filtersShow, #filtersHide").toggle();
  });

  const pfgradeToggle = document.getElementById("pfgradeToggle");
  if (pfgradeToggle) {
    pfgradeToggle.addEventListener("change", function () {
      const url = new URL(window.location.href);
      const params = url.searchParams;

      if (this.checked) {
        params.set("pfgrade", "true");
      } else {
        params.delete("pfgrade");
      }

      // Always go to page 1 when changing filters
      params.delete("page");

      // Redirect with updated query string
      url.search = params.toString();
      window.location.href = url.toString();
    });
  }
});
